<template>
  <v-container fluid style="padding:0">
      <v-form :key="obschange" v-if="obsVal" :disabled="readonly" ref="obsform" v-model="obsValidInt">
        <v-row no-gutters class="pb-0" style="height:50px;">
            <v-col cols="3">
                <v-select
                    class="demofields tallField"
                    dense
                    outlined
                    v-model="obsVal.overall.initialObsDepartment"
                    :items="departments"
                    :label="(qaEnc && obsQaVal && obsQaVal.entries.overall.initialObsDepartment ? 'Initial Dept: ' + obsQaVal.entries.overall.initialObsDepartment + (obsQaVal.entries.overall.initialObsDepartment == obsVal.overall.initialObsDepartment ? ' - ✓' : ' - ✗' ) : 'Initial Obs Department')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    @input="obsCalc"
                ></v-select>
            </v-col>
            <v-col cols="3">
                <v-select
                    class="demofields tallField"
                    dense
                    outlined
                    v-model="obsVal.overall.obsPatientArrivalSource"
                    :items="obsArrivalSources"
                    :label="(qaEnc && obsQaVal && obsQaVal.entries.overall.obsPatientArrivalSource ? 'Arrival Src: ' + obsQaVal.entries.overall.obsPatientArrivalSource + (obsQaVal.entries.overall.obsPatientArrivalSource == obsVal.overall.obsPatientArrivalSource ? ' - ✓' : ' - ✗' ) : 'Patient Arrival Source')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    @input="obsCalc"
                ></v-select>
            </v-col>
            <v-col cols="2" style="height:50px;" :class="'text-center ' + (proMode ? 'checkBoxBorderedDK' : 'checkBoxBorderedLT')">
                <v-checkbox @change="code44" 
                    style="margin:7px 5px;"
                    class="nextDay"
                    v-model="obsVal.overall.code44"
                    :label="(qaEnc && obsQaVal ? '44: ' + obsQaVal.entries.overall.code44 + (obsQaVal.entries.overall.code44 == obsVal.overall.code44 ? ' - ✓' : ' - ✗' ) : 'Code 44')"
                ></v-checkbox>
            </v-col>
            <v-col cols="2">
                <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :disabled="readonly || !obsVal.overall.code44"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        class="demofields tallField activeLabelOver"
                        v-model="obsVal.overall.code44Date"
                        :rules="fieldRuleDep(obsVal.overall.code44Date,'obs_code44Date',obsVal.overall.code44)"
                        :label="(qaEnc && obsQaVal.overall.code44Date ? '44 Date: ' + obsQaVal.overall.code44Date + (obsQaVal.overall.code44Date == obsVal.overall.code44Date ? ' - ✓' : ' - ✗' ) : '44 Date')"
                        dense
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="obsVal.overall.code44Date"
                        @input="menu3 = false"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="2">
                <v-text-field
                    class="demofields tallField"
                    v-model="obsVal.overall.code44Time"
                    :rules="fieldRuleDep(obsVal.overall.code44Time,'obs_code44Time',obsVal.overall.code44)"
                    :label="(qaEnc && obsQaVal.overall.code44Time ? '44 Time: ' + obsQaVal.overall.code44Time + (obsQaVal.overall.code44Time == obsVal.overall.code44Time ? ' - ✓' : ' - ✗' ) : '44 Time')"
                    :class="(qaEnc ? 'activeLabelOver' : '')"
                    dense
                    outlined
                    clearable
                    :disabled="!obsVal.overall.code44"
                    type="time"
                ></v-text-field>
            </v-col>
        </v-row>

        <div v-for="(obs, obsind) in obsVal.entries.obs" :style="(obs.duplicate || obs.invalid_push ? 'border: solid 2px #ff5252;min-height: 158px;margin-bottom: 16px;' :'')" :key="'obs_' + obsind">
            <!-- <v-row v-if="obs.duplicate" style="margin-bottom:-5px" no-gutters class>
                <v-col style="padding:0; background-color:#ff5252;" cols="12">
                    <h3 style="color:white; text-align:center; font-style:italic;">THIS IS A DUPLICATE ENTRY AND WILL NOT BE CALCULATED!</h3>
                </v-col>
            </v-row> -->
            <v-row no-gutters> 
                <v-col style="padding:0" cols="11">
                    <v-row no-gutters style="height:40px;margin-top:22px;">
                        <v-col cols="2">
                            <v-select
                                class="demofields"
                                dense
                                :label="(qaEnc && obsQaVal.entries.obs[obsind] ? 'Dept: ' + obsQaVal.entries.obs[obsind].department + (obsQaVal.entries.obs[obsind].department == obs.department ? ' - ✓' : ' - ✗' ) : 'Department')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                v-model="obs.department"
                                :rules="fieldRule(obs.department,'obs_department')"
                                @input="obsCalc"
                                outlined
                                :items="departments"
                            ></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-menu
                                v-model="menu1[obsind]"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                :disabled="readonly"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="demofields"
                                    v-model="obs.startDate"
                                    :rules="fieldRuleDep(obs.startDate,'obs_startDate',obs.department)"
                                    :label="(qaEnc && obsQaVal.entries.obs[obsind] ? 'Start Date: ' + obsQaVal.entries.obs[obsind].startDate + (obsQaVal.entries.obs[obsind].startDate == obs.startDate ? ' - ✓' : ' - ✗' ) : 'Start Date')"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    dense
                                    outlined
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="obs.startDate"
                                    @input="menu1[obsind] = false; obsCalc();"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                class="demofields"
                                v-model="obs.startTime"
                                :rules="fieldRuleDep(obs.startTime,'obs_startTime',obs.department)"
                                :label="(qaEnc && obsQaVal.entries.obs[obsind] ? 'Start Time: ' + obsQaVal.entries.obs[obsind].startTime + (obsQaVal.entries.obs[obsind].startTime == obs.startTime ? ' - ✓' : ' - ✗' ) : 'Start Time')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                dense
                                outlined
                                clearable
                                @blur="obsCalc"
                                @input="obsCalc"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-menu
                                v-model="menu2[obsind]"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                                :disabled="readonly"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="demofields"
                                    v-model="obs.stopDate"
                                    :rules="fieldRuleDep(obs.stopDate,'obs_stopDate',obs.department)"
                                    :label="(qaEnc && obsQaVal.entries.obs[obsind] ? 'Stop Date: ' + obsQaVal.entries.obs[obsind].stopDate + (obsQaVal.entries.obs[obsind].stopDate == obs.stopDate ? ' - ✓' : ' - ✗' ) : 'Stop Date')"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    dense
                                    outlined
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="obs.stopDate"
                                    @input="menu2[obsind] = false; obsCalc();"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                class="demofields"
                                v-model="obs.stopTime"
                                :rules="fieldRuleDep(obs.stopTime,'obs_stopTime',obs.department)"
                                :label="(qaEnc && obsQaVal.entries.obs[obsind] ? 'Stop Time: ' + obsQaVal.entries.obs[obsind].stopTime + (obsQaVal.entries.obs[obsind].stopTime == obs.stopTime ? ' - ✓' : ' - ✗' ) : 'Stop Time')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                dense
                                outlined
                                clearable
                                @blur="obsCalc"
                                @input="obsCalc"
                                type="time"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                class="demofields"
                                v-model="obs.totalHours"
                                :label="(qaEnc && obsQaVal.entries.obs[obsind] ? 'T: ' + obsQaVal.entries.obs[obsind].totalHours + (obsQaVal.entries.obs[obsind].totalHours == obs.totalHours ? ' - ✓' : ' - ✗' ) : 'Total')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                style="font-weight:bold;"
                                dense
                                outlined
                                suffix="hr(s)"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                class="demofields"
                                v-model="obs.exclusionHours"
                                :label="(qaEnc && obsQaVal.entries.obs[obsind] ? 'E: ' + obsQaVal.entries.obs[obsind].exclusionHours + (obsQaVal.entries.obs[obsind].exclusionHours == obs.exclusionHours ? ' - ✓' : ' - ✗' ) : 'Excl')"
                                :class="(qaEnc ? 'activeLabelOver' : '')"
                                style="font-weight:bold;"
                                dense
                                outlined
                                suffix="hr(s)"
                                readonly
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col style="padding:0" cols="1">
                    <v-row no-gutters style="margin-bottom:5px;margin-top:20px;">
                        <v-spacer></v-spacer>
                        <v-col style="padding:0" cols="9">
                            <v-btn
                                depressed
                                x-small
                                color="error"
                                :outlined="proMode"
                                style="border-radius:0"
                                block
                                @click="deleteRow('obs',obsind,null)"
                                :disabled="readonly"
                            >
                                -
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-spacer></v-spacer>
                        <v-col style="padding:0" cols="9">
                            <v-btn
                                depressed
                                x-small
                                block
                                color="success"
                                :outlined="proMode"
                                style="border-radius:0"
                                @click="addRow('obs',obsind,null)"
                                :disabled="readonly"
                            >
                                +
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <div v-for="(exc, excind) in obsVal.entries.obs[obsind].exclusions" :key="'obs_exlc_' + excind">
                <v-row no-gutters>
                    <v-col style="padding:0;" cols="1" >
                        <v-row justify="space-around">
                            <v-icon
                                style="transform: scaleX(-1);margin-top:12px;"
                                x-large
                            >
                                mdi-keyboard-return
                            </v-icon>
                        </v-row>
                    </v-col>
                    <v-col style="padding:0;" cols="1" >
                        <v-row no-gutters style="margin-bottom:5px;margin-top:10px;">
                            <v-col style="padding:0" cols="9">
                                <v-btn
                                    depressed
                                    x-small
                                    color="error"
                                    :outlined="proMode"
                                    style="border-radius:0"
                                    block
                                    @click="deleteRow('exc',obsind,excind)"
                                    :disabled="readonly"
                                >
                                    -
                                </v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                        <v-row no-gutters>
                            <v-col style="padding:0" cols="9">
                                <v-btn
                                    depressed
                                    x-small
                                    block
                                    color="success"
                                    :outlined="proMode"
                                    style="border-radius:0"
                                    @click="addRow('exc',obsind,excind)"
                                    :disabled="readonly"
                                >
                                    +
                                </v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                    </v-col>
                    <v-col cols="9" style="margin-bottom:5px;margin-top:12px;">
                        <v-row no-gutters>
                            <v-col cols="6">
                                <v-select
                                    class="demofields"
                                    dense
                                    :label="(qaEnc && obsQaVal.entries.obs[obsind].exclusions[excind] ? 'Exclusion Reason: ' + obsQaVal.entries.obs[obsind].exclusions[excind].reason + (obsQaVal.entries.obs[obsind].exclusions[excind].reason == exc.reason ? ' - ✓' : ' - ✗' ) : 'Exclusion Reason')"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    v-model="exc.reasonObj"
                                    @input="exc.reason = countExclusionHours(exc.reasonObj,obsind,excind)"
                                    return-object
                                    outlined
                                    :items="obsExclusionReasons"
                                    item-text="reason"
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    class="demofields"
                                    v-model="exc.hours"
                                    :label="(qaEnc && obsQaVal.entries.obs[obsind].exclusions[excind] ? 'Hours: ' + obsQaVal.entries.obs[obsind].exclusions[excind].hours + (obsQaVal.entries.obs[obsind].exclusions[excind].hours == exc.hours ? ' - ✓' : ' - ✗' ) : 'Hours')"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    style="font-weight:bold;"
                                    dense
                                    outlined
                                    suffix="hr(s)"
                                    type="number"
                                    @blur="obsCalc"
                                    @input="obsCalc"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    class="demofields"
                                    v-model="exc.minutes"
                                    :label="(qaEnc && obsQaVal.entries.obs[obsind].exclusions[excind] ? 'Mins: ' + obsQaVal.entries.obs[obsind].exclusions[excind].minutes + (obsQaVal.entries.obs[obsind].exclusions[excind].minutes == exc.minutes ? ' - ✓' : ' - ✗' ) : 'Minutes')"
                                    :class="(qaEnc ? 'activeLabelOver' : '')"
                                    style="font-weight:bold;"
                                    dense
                                    outlined
                                    suffix="min(s)"
                                    type="number"
                                    @blur="obsCalc"
                                    @input="obsCalc"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>
            </div>
        </div>

        <v-row no-gutters>
            <v-col cols="12" class="mt-2">
                <v-btn v-if="lastChanceUndo" class="my-2" small block color="warning" @click="undoResults">Undo Clear All ({{undoTimeLeft}}s left)</v-btn>
                <v-btn v-else class="my-2" :disabled="readonly" small block color="error" @click="clearResultsDialog">Clear All Entries</v-btn>
            </v-col>
        </v-row>

        <v-row v-if="!noCalc" no-gutters class="mb-0 mx-0" style="margin-top:20px;margin-left:-16px !important;margin-right:-16px !important;">
            <v-col cols="12">
                <v-tabs
                    :dark="proMode"
                    show-arrows
                    v-model="restab"
                    :background-color = "(proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"
                    grow
                    height="35"
                >
                    <v-tabs-slider :color="proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'"></v-tabs-slider>
                    <v-tab 
                        key="res"
                        :dark="proMode"
                        :style="'border-right:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                    >
                        OBS CALC RESULTS ({{obsVal.results.length}})
                    </v-tab>
                    <!-- <v-tab 
                        key="fixres"
                        v-if="obsVal.fixed_results && $store.getters.obsDispFixed"
                        :dark="proMode"
                        :style="'border-right:thin solid ' + (proMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)')"
                    >
                        OBS POTENTIAL RESULTS ({{obsVal.fixed_results.length}}) - {{(difRes ? 'DIFF' : 'SAME')}}
                    </v-tab> -->
                </v-tabs>
                <v-tabs-items :style="'border:solid 1px ' + (proMode ? 'rgba(255, 255, 255, 0.12)':'rgba(0, 0, 0, 0.12)')"  :dark="proMode" v-model="restab">
                    <v-tab-item 
                        key="res" 
                        :dark="proMode" 
                        style="margin-top:10px;margin-right:16px !important;margin-left:16px !important;padding-bottom:10px;"
                    >
                        <div v-if="obsVal.results.length>0">
                            <div v-for="(obsDos, odosind) in sortedResults.obsDoss" :key="'obsDos_' + odosind">
                                <v-row no-gutters>
                                        <v-col style="padding:0" cols="4">
                                            <h3 style="margin-bottom:10px; font-size: 1.3em;">{{obsDos}}</h3>
                                        </v-col>
                                        <v-col v-if="odosind==0">
                                            <v-switch
                                                style="padding:0;margin:0;"
                                                v-model="obsVal.overall.resOverride"
                                                label="Override Results"
                                            ></v-switch>
                                        </v-col>
                                        <v-col v-if="odosind==0" style="padding:0" cols="2">
                                            <v-btn class="float-right mt-n2" icon @click="obsCalc">
                                                <v-icon>mdi-cached</v-icon>
                                            </v-btn> 
                                        </v-col>
                                </v-row>
                                <div v-for="(res, resind) in sortedResults.results[obsDos]" :key="'res_' + resind">
                                    <v-row no-gutters>
                                        <v-col style="padding:0" cols="12">
                                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                                <v-col cols="2">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        label="Department"
                                                        outlined
                                                        v-model="res.department"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Qty"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        type="number"
                                                        min="1"
                                                        v-model="res.qty"
                                                        readonly
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Code"
                                                        outlined
                                                        v-model="res.code"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Description"
                                                        outlined
                                                        :value="codeDescr(res.code)"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-combobox
                                                        v-model="res.mods"
                                                        @input="res.mods = allCapArray(res.mods)"
                                                        :items="$store.getters.obsMods"
                                                        :label="(qaEnc && obsQaVal.results[resind] ? 'Mods: ' + modStringer(obsQaVal.results[resind].mods) + (obsQaVal.results[resind].mods.toString() == res.mods.toString() ? ' - ✓' : ' - ✗' ) : 'Modifiers')"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        multiple
                                                        :disabled="odosind>0"
                                                        outlined
                                                        dense
                                                    >
                                                        <template v-slot:selection="{ attrs, item, parent, selected }">
                                                            <v-chip
                                                            v-if="item === item"
                                                            v-bind="attrs"
                                                            :input-value="selected"
                                                            label
                                                            small
                                                            outlined
                                                            >
                                                            <span class="pr-2">
                                                                {{ item }}
                                                            </span>
                                                            <v-icon
                                                                x-small
                                                                @click="parent.selectItem(item)"
                                                            >
                                                                mdi-close

                                                            </v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </v-combobox>
                                                </v-col>
                                                <v-col cols="1">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Excl"
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                        type="number"
                                                        min="0"
                                                        v-model="res.exclusionTime"
                                                        readonly
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                                <!-- <v-col cols="3">
                                                    <v-text-field
                                                        class="demofields"
                                                        dense
                                                        style="font-size:14px;font-weight:bold;"
                                                        label="Date Performed"
                                                        outlined
                                                        v-model="res.dos"
                                                        readonly
                                                        :class="(qaEnc ? 'activeLabelOver' : '')"
                                                    ></v-text-field>
                                                </v-col> -->
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-divider style="margin-bottom: 10px;" v-if="sortedResults.obsDoss.length != odosind+1"></v-divider>
                            </div>
                        </div>
                        <div class="pb-4" v-else>
                            <v-row no-gutters>
                                <v-col style="padding:0" cols="10">
                                    <h4>Results pending entries...</h4>
                                </v-col>
                                <v-col style="padding:0" cols="2">
                                    <v-btn class="float-right mt-n2" icon @click="obsCalc">
                                        <v-icon>mdi-cached</v-icon>
                                    </v-btn> 
                                </v-col>
                            </v-row>
                        </div>
                    </v-tab-item>
                    <!-- <v-tab-item 
                        key="fixres" 
                        v-if="obsVal.fixed_results && $store.getters.obsDispFixed"
                        :dark="proMode" 
                        style="margin-top:10px;margin-right:16px !important;margin-left:16px !important;padding-bottom:10px;"
                    >
                        <div v-if="obsVal.fixed_results.length>0">
                            <div v-for="(obsDos, odosind) in sortedFixedResults.obsDoss" :key="'obsDos_' + odosind">
                                <v-row no-gutters>
                                        <v-col style="padding:0" cols="10">
                                            <h3 style="margin-bottom:10px; font-size: 1.3em;">{{obsDos}}</h3>
                                        </v-col>
                                        <v-col v-if="odosind==0" style="padding:0" cols="2">
                                            <v-btn class="float-right mt-n2" icon @click="obsCalc">
                                                <v-icon>mdi-cached</v-icon>
                                            </v-btn> 
                                        </v-col>
                                </v-row>
                                <div v-for="(res, resind) in sortedFixedResults.results[obsDos]" :key="'res_' + resind">
                                    <v-row no-gutters>
                                        <v-col style="padding:0" cols="12">
                                            <v-row no-gutters style="height:40px;margin-top:5px;">
                                                
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-divider style="margin-bottom: 10px;" v-if="sortedFixedResults.obsDoss.length != odosind+1"></v-divider>
                            </div>
                        </div>
                        <div class="pb-4" v-else>
                            <h4>Results pending entries...</h4>
                        </div>
                    </v-tab-item> -->
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-form>
    <v-dialog
        v-model="clearResDiag"
        width="350"
    >
        <v-card>
            <v-card-title class="headline red darken-2 white--text pl-4 pb-2">
            Are you sure?
            </v-card-title>

            <v-card-text class="pt-5">
            This will remove all results that have been entered to this point. You have spent {{timeSinceOpen}} mins on this chart, please be sure before proceeding.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="clearResults"
            >
                Confirm Clear Results
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { ulid } from 'ulid';

export default{
  name: 'OBSCALC',
    props: {
        obsVal:{
            type:Object,
            required:false
        },
        obsQaVal:{
            type:Object,
            required:false
        },
        timeOpened:{
            type:Number,
            required:true
        },
        obsValid:{
            type:Boolean,
            required:false
        },
        qaEnc:{
            type:Boolean,
            required:false
        },
        readonly:{
            type:Boolean,
            required:false
        },
    },
    components: { 
    },
    data() {
        return {
            isLoading:false,
            obsValidInt:false,
            undoEnc:{},
            lastChanceUndo:false,
            countdownInt:null,
            undoTimeLeft:15,
            timeSinceOpen:0,
            clearResDiag: false,

            descriptionLimit: 50,
            entries: [],
            isLoading: false,
            model: null,

            obschange: 0,
            injchange: 0,

            menu1:[false],
            menu2:[false],
            menu3:false,
            restab:"",
            difRes: false,

            fieldRule: function(v,f){
                let out = true;
                // if(this.reqCheck(f) && !v){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
            fieldRuleDep: function(v,f,df){
                let out = true;
                if(df && this.reqCheck(f) && !v){
                    //out = 'Field Required to QA/Complete';
                    out='';
                }else{
                }
                return [out];
            },
            fieldRuleInd: function(v,f,ind){
                // let fArr = f.split("_"),
                //     fComb = fArr[0] + "_" + ind + "_" + fArr[1];
                let out = true;
                // if(this.reqCheck(fComb) && !v.code){
                //     out = 'Field Required to QA/Complete';
                // }else{
                // }
                return [out];
            },
        };
    },
    computed:{
        ...mapGetters(["facSettings","noCalc","proMode","departments","obsExclusionReasons","obsArrivalSources"]),
        items () {
            return this.entries.map(entry => {
            const Description = entry.code + " - " + (entry.name.length > this.descriptionLimit
                ? entry.name.slice(0, this.descriptionLimit) + '...'
                : entry.name)

            return Object.assign({}, entry, { Description })
            })
        },
        sortedResults(){
            let out = {
                    results:{},
                    obsDoss:[]
                },
                res = this.obsVal.results;
            if(res.length>0){
                for(let r=0; r<res.length; r++){
                    if(out.results[res[r].dos]){
                        out.results[res[r].dos].push(res[r]);
                    }else{
                        out.results[res[r].dos] = [res[r]];
                        out.obsDoss.push(res[r].dos);
                    }
                }
                out.obsDoss = [...new Set(out.obsDoss)];
                out.obsDoss.sort();
            }
            return out;
        },
        // sortedFixedResults(){
        //     let out = {
        //             results:{},
        //             obsDoss:[]
        //         },
        //         res = this.obsVal.fixed_results;
        //     if(res.length>0){
        //         for(let r=0; r<res.length; r++){
        //             if(out.results[res[r].dos]){
        //                 out.results[res[r].dos].push(res[r]);
        //             }else{
        //                 out.results[res[r].dos] = [res[r]];
        //                 out.obsDoss.push(res[r].dos);
        //             }
        //         }
        //         out.obsDoss = [...new Set(out.obsDoss)];
        //         out.obsDoss.sort();
        //     }
        //     return out;
        // },
    },
    watch:{
      obsValidInt(val){
          this.$emit('validChanged', val);
      }
    },
    mounted: function(){
        if(!this.obsVal){
            this.obsVal = {
                "overall":{
                    "code44":false,
                    "initialObsDepartment":"",
                    "obsPatientArrivalSource":""
                },
                "entries":{
                    "obs":[{
                        "id": ulid(),
                        "department":"",
                        "startDate":"",
                        "startTime":"",
                        "stopDate":"",
                        "stopTime":"",
                        "exclusionHours":0,
                        "totalHours":0,
                        "exclusions":[]
                    }]
                },
                "totals":{
                    "totalHours":0,
                    "totalExclusions":0
                },
                "results":[]
            };
        }
    },
    methods: {
        code44(val){
            if(!val){
                this.obsVal.overall.code44Date = "";
                this.obsVal.overall.code44Time = "";
                //this.obschange++
            }
        },
        obsCalc(){
            // console.log("CALC OBS");
            this.reCountTotalHours();
            // console.log(JSON.stringify(this.obsVal.totals));
            // console.log(JSON.stringify(this.obsVal.entries.obs));
            let dateObs = {},totalHours=0,allDateArr=[];
            if(this.obsVal.totals.totalHours>this.obsVal.totals.totalExclusions){
                let alreadyExcl = false, firstDayTooShort = false;
                for (let e=0; e<this.obsVal.entries.obs.length; e++){
                    if(this.obsVal.entries.obs[e].totalHours>0){
                        // console.log("ENTRY " + e + ":" + this.obsVal.entries.obs[e].totalHours);
                        if(this.obsVal.entries.obs[e].totalHours>this.obsVal.entries.obs[e].exclusionHours){
                            // console.log("CALCABLE ENTRY");
                            let dateArr = this.getDates(this.obsVal.entries.obs[e].startDate,this.obsVal.entries.obs[e].stopDate),
                                entryHours = this.obsVal.entries.obs[e].totalHours;
                                //entryHours = this.obsVal.totals.totalHours,
                                // alreadyExcl = false, firstDayTooShort = false;
                            allDateArr = [...new Set([...allDateArr,...dateArr])];
                            // COMBINE HOURS BY DATE AND DEPARTMENT
                            for (let d=0; d<dateArr.length; d++){
                                let exclusionHours = 0,
                                    dstart = new Date(dateArr[d] + "T00:00"),
                                    dstop = new Date(dateArr[d] + "T23:59");

                                if(d==0){
                                    dstart = new Date(dateArr[d] + "T" + this.obsVal.entries.obs[e].startTime);
                                    if(dateArr.length>1){
                                        dstop = new Date(dateArr[d] + "T23:59");
                                    }else{
                                        dstop = new Date(dateArr[d] + "T" + this.obsVal.entries.obs[e].stopTime);
                                    }
                                }

                                let ddiff = Math.abs(dstart - dstop),
                                    dosHours = Math.round((ddiff/1000)/60/60);
                                
                                if(d==dateArr.length-1){
                                    // dstart = new Date(dateArr[d] + "T00:00");
                                    // dstop = new Date(dateArr[d] + "T" + this.obsVal.entries.obs[e].stopTime);
                                    dosHours = entryHours;
                                }

                                entryHours = entryHours-dosHours;
                                // console.log("START DAY: " + d + " | exclH: " + this.obsVal.entries.obs[e].exclusionHours + " | dosH: " + dosHours + " | entryH: " + entryHours);
                                
                                if(!alreadyExcl && d==0 && dosHours>this.obsVal.entries.obs[e].exclusionHours){
                                    exclusionHours = this.obsVal.entries.obs[e].exclusionHours;
                                    dosHours = dosHours-exclusionHours;
                                    entryHours = entryHours+exclusionHours;
                                    alreadyExcl = true;
                                    // console.log("FIRST DAY EXCLUDABLE");
                                }else if(!alreadyExcl && d==0 && dosHours<=this.obsVal.entries.obs[e].exclusionHours){
                                    firstDayTooShort = true;
                                    // console.log("FIRST DAY TOO SHORT");
                                }else if(firstDayTooShort){
                                    exclusionHours = this.obsVal.entries.obs[e].exclusionHours;
                                    dosHours = dosHours-exclusionHours;
                                    entryHours = entryHours+exclusionHours;
                                    firstDayTooShort = false;
                                    alreadyExcl = true;
                                    // console.log("SECOND DAY");
                                }else if(d==dateArr.length-1){
                                    dosHours = dosHours-this.obsVal.entries.obs[e].exclusionHours;
                                    // console.log("LAST DAY");
                                }
                                // else if(d!=0 && !alreadyExcl){
                                //     exclusionHours = this.obsVal.entries.obs[e].exclusionHours;
                                //     dosHours = dosHours-exclusionHours;
                                //     entryHours = entryHours+exclusionHours;
                                //     alreadyExcl = true;
                                // }
                                // console.log("DAY: " + d + " | exclH: " + exclusionHours + " | dosH: " + dosHours + " | entryH: " + entryHours);
                                if(dateObs[dateArr[d]]){
                                    if(dateObs[dateArr[d]][this.obsVal.entries.obs[e].department]){
                                        dateObs[dateArr[d]][this.obsVal.entries.obs[e].department].totalHours += dosHours;
                                        dateObs[dateArr[d]][this.obsVal.entries.obs[e].department].exclusionHours += exclusionHours;
                                    }else{
                                        dateObs[dateArr[d]][this.obsVal.entries.obs[e].department] = {};
                                        dateObs[dateArr[d]][this.obsVal.entries.obs[e].department].totalHours = dosHours;
                                        dateObs[dateArr[d]][this.obsVal.entries.obs[e].department].exclusionHours = exclusionHours;
                                    }
                                }else{
                                    dateObs[dateArr[d]] = {};
                                    dateObs[dateArr[d]][this.obsVal.entries.obs[e].department] = {};
                                    dateObs[dateArr[d]][this.obsVal.entries.obs[e].department].totalHours = dosHours;
                                    dateObs[dateArr[d]][this.obsVal.entries.obs[e].department].exclusionHours = exclusionHours;
                                }
                            }
                            totalHours += this.obsVal.entries.obs[e].totalHours;
                        }else if(e==0){
                            // console.log("NOT CALCABLE FIRST ENTRY");
                            alreadyExcl = true;
                            firstDayTooShort = true;
                            // let dateArr = this.getDates(this.obsVal.entries.obs[e].startDate,this.obsVal.entries.obs[e].stopDate);
                            // if(dateObs[dateArr[0]]){
                            //     if(dateObs[dateArr[0]][this.obsVal.entries.obs[e].department]){
                            //         dateObs[dateArr[0]][this.obsVal.entries.obs[e].department].totalHours = 0;
                            //         dateObs[dateArr[0]][this.obsVal.entries.obs[e].department].exclusionHours = 0;
                            //     }else{
                            //         dateObs[dateArr[0]][this.obsVal.entries.obs[e].department] = {};
                            //         dateObs[dateArr[0]][this.obsVal.entries.obs[e].department].totalHours = 0;
                            //         dateObs[dateArr[0]][this.obsVal.entries.obs[e].department].exclusionHours = 0;
                            //     }
                            // }else{
                            //     dateObs[dateArr[0]] = {};
                            //     dateObs[dateArr[0]][this.obsVal.entries.obs[e].department] = {};
                            //     dateObs[dateArr[0]][this.obsVal.entries.obs[e].department].totalHours = 0;
                            //     dateObs[dateArr[0]][this.obsVal.entries.obs[e].department].exclusionHours = 0;
                            // }
                        }else{
                            // console.log("NOT CALCABLE OTHER ENTRY");
                        }
                    }
                }
            }
            let out=[];
            if(allDateArr.length>0){
                allDateArr.sort();
                let firstDept = Object.keys(dateObs[allDateArr[0]])[0];
                // START PUSHING CPTS
                // CHECK FOR G0379
                if(this.obsVal.overall.obsPatientArrivalSource == "Direct to Obs" && totalHours > 0){
                    out.push({
                        "id": ulid(),
                        "department":firstDept,
                        "code":"G0379",
                        "mods":[],
                        "qty":1,
                        "dos":allDateArr[0],
                        "exclusionTime":0
                    });
                    totalHours--;
                    dateObs[allDateArr[0]][firstDept].totalHours--;
                }
                // COUNT THE REST OF THE HOURS
                if(totalHours>0){
                    for (let a=0; a<allDateArr.length; a++){
                        let depts = Object.keys(dateObs[allDateArr[a]]);
                        for (let ad=0; ad<depts.length; ad++){
                            out.push({
                                "id": ulid(),
                                "department":depts[ad],
                                "code":"G0378",
                                "mods":[],
                                "qty":dateObs[allDateArr[a]][depts[ad]].totalHours,
                                "dos":allDateArr[a],
                                "exclusionTime":dateObs[allDateArr[a]][depts[ad]].exclusionHours
                            });
                        }
                    }
                }
            }

            this.obsVal.results = out;
        },
        getDates(startDate, stopDate) {
            let start = new Date(startDate),
                stop = new Date(stopDate),
                dateArray = new Array(),
                currentDate = start;
            while (currentDate <= stop) {
                dateArray.push(currentDate.toISOString().split("T")[0]);
                currentDate = this.addDays(currentDate,1);
            }
            return dateArray;
        },
        addDays(date,days) {
            date.setDate(date.getDate() + days);
            return date;
        },
        codeDescr(code){
            let conv = {"G0379":"Direct to OBS","G0378":"OBS Hour(s)"};
            return conv[code];
        },
        modStringer(mods){
            let out = "";
            for(let m=0; m<mods.length; m++){
                out += mods[m] + (mods.length != m+1 ? ", " : "");
            }
            return out;
        },
        clearResultsDialog(){
            this.clearResDiag = true;
            let d = new Date().getTime(),
                diff = Math.abs(d - this.timeOpened),
                out = Math.floor((diff/1000)/60);
            this.timeSinceOpen = out;
        },
        clearResults(){
            this.clearResDiag = false;
            this.undoEnc = JSON.parse(JSON.stringify(this.obsVal));
            this.obsVal.entries = {
                "obs":[{
                        "id": ulid(),
                        "department":"",
                        "startDate":"",
                        "startTime":"",
                        "stopDate":"",
                        "stopTime":"",
                        "exclusionHours":0,
                        "totalHours":0,
                        "exclusions":[{
                            "reason":"",
                            "hours":0,
                            "minutes":0
                        }]
                    }]
            };
            this.obsVal.results = [];
            this.lastChanceUndo = true;
            this.countdownTimer();
        },
        undoResults(){
            this.obsVal = this.undoEnc;
            this.lastChanceUndo = false;
            clearInterval(this.countdownInt);
        },
        countdownTimer(){
            //// console.log("COUNTING DOWN " + this.undoTimeLeft);
            const self = this;
            this.countdownInt = setInterval(function() {
                //// console.log("TL: " + self.undoTimeLeft);
                self.undoTimeLeft--;
                if (self.undoTimeLeft < 0) {
                    //// console.log("TIMER DONE");
                    clearInterval(self.countdownInt);
                    self.lastChanceUndo = false;
                    self.undoEnc = {};
                    self.undoTimeLeft = 15;
                }
            }, 1000);
        },
        obsValidCheck(ind){
            let fComb = "OBS_" + ind + "_drug";
            let out = false;
            if(this.reqCheck(fComb)){
                //// console.log(ind + " obs REQUIRED!");
                //// console.log("VALUE: " + JSON.stringify(this.obsVal.entries.obs[ind].drug));
                if(this.obsVal.entries.obs[ind].drug == "" || !this.obsVal.entries.obs[ind].drug){
                    out = false;
                }else{
                    out = true;
                }
            }else{
                out = true
            }
            return out;
        },
        validateform(){
            this.validate();
        },
        reqCheck(field){
            let out = false;
            if(this.$store.getters.requiredFields.indexOf(field)>=0){
                out = true;
            }
            //// console.log("REQ CHECK: " + field + ": " + out);
            return out;
        },
        deleteRow(type,ind,excind){
            let d = new Date().getTime();
            switch(type){
                case "obs":
                    if(this.obsVal.entries.obs.length == 1){
                        this.obsVal.entries.obs[0] = {
                            "id": ulid(),
                            "department":"",
                            "startDate":"",
                            "startTime":"",
                            "stopDate":"",
                            "stopTime":"",
                            "exclusionHours":0,
                            "totalHours":0,
                            "exclusions":[{
                                "reason":"",
                                "hours":0,
                                "minutes":0
                            }]
                        };
                    }else{
                        this.obsVal.entries.obs.splice(ind, 1)
                    } 
                    this.obsCalc();
                    this.obschange++;
                    break;
                case "exc":
                    if(this.obsVal.entries.obs[ind].exclusions.length == 1){
                        this.obsVal.entries.obs[ind].exclusions[0] = {
                            "reason":"",
                            "hours":0,
                            "minutes":0
                        };
                    }else{
                        this.obsVal.entries.obs[ind].exclusions.splice(excind, 1);
                    } 
                    //this.reCountTotalHours();
                    this.obsCalc();
                    this.obschange++;
                    break;
            }
        },
        copyRow(type,ind){
            let d = new Date().getTime();
            switch(type){
                case "obs":
                    this.obsVal.entries.obs.splice(ind + 1, 0, {
                        "id": ulid(),
                        "department":this.obsVal.entries.obs[ind].department,
                        "startDate":this.obsVal.entries.obs[ind].startDate,
                        "startTime":this.obsVal.entries.obs[ind].startTime,
                        "stopDate":this.obsVal.entries.obs[ind].stopDate,
                        "stopTime":this.obsVal.entries.obs[ind].stopTime,
                        "exclusionHours":this.obsVal.entries.obs[ind].exclusionHours,
                        "totalHours":this.obsVal.entries.obs[ind].totalHours,
                        "exclusions":this.obsVal.entries.obs[ind].exclusions
                    });
                    this.obschange++;
                    this.obsCalc();
                    break;
            }              
        },
        addRow(type,ind,excind){
            let d = new Date().getTime();
            switch(type){
                case "obs":
                    this.obsVal.entries.obs.splice(ind + 1, 0, {
                        "id": ulid(),
                        "department":"",
                        "startDate":"",
                        "startTime":"",
                        "stopDate":"",
                        "stopTime":"",
                        "exclusionHours":0,
                        "totalHours":0,
                        "exclusions":[{
                            "reason":"",
                            "hours":0,
                            "minutes":0
                        }]
                    });                    
                    this.obschange++;
                    break;
                case "exc":
                    this.obsVal.entries.obs[ind].exclusions.splice(excind + 1, 0, {
                        "reason":"",
                        "hours":0,
                        "minutes":0
                    });                    
                    this.obschange++;
                    break;
            }              
        },
        moveRow(type,ind,dir){
            //// console.log(type + " | " + ind + " | " + dir);
            let c = this.obsVal.entries[type].splice(ind,1)[0];
            switch(dir){
                case "up":
                    this.obsVal.entries[type].splice(ind - 1, 0, c);
                    break;
                case "down":
                    this.obsVal.entries[type].splice(ind + 1, 0, c);
                    break;
            }
            if(type == "obs"){
                this.obschange++;
            }
            
        },
        countExclusionHours(reason,obsind,excind){
            if(reason.type == "average"){
                this.obsVal.entries.obs[obsind].exclusions[excind].hours = reason.hours;
                this.obsVal.entries.obs[obsind].exclusions[excind].minutes = reason.minutes;
            }
            this.reCountTotalHours();
            this.obsCalc();
            return reason.reason;
        },
        countTotalHours(obs,noCalc){
            let out = 0;
            if(obs.startDate && obs.startTime && obs.stopDate && obs.stopTime){
                let excl = 0;
                for (let e=0; e<obs.exclusions.length; e++){
                    let ehours = (obs.exclusions[e].hours ? obs.exclusions[e].hours : 0),emins = (obs.exclusions[e].minutes ? obs.exclusions[e].minutes : 0);
                    excl += Number(ehours) + Number(emins/60)
                }
                excl = Math.round(excl);
                // console.log("EXCL: " + excl);
                obs.exclusionHours = excl;
                let start = new Date(obs.startDate + "T" + obs.startTime),
                    stop = new Date(obs.stopDate + "T" + obs.stopTime);
                if(start > stop){
                    out = 0;
                }else{
                    let diff = Math.abs(start - stop),
                    hoursDiff = Math.round((diff/1000)/60/60);//-excl;
                    if(hoursDiff>0){
                        out = hoursDiff;
                    }
                }
            }
            obs.totalHours = out;
            if(!noCalc){
                this.obsCalc();
                return out;
            }
        },
        reCountTotalHours(){
            this.obsVal.totals = {
                totalHours:0,
                totalExclusions:0
            };
            for (let o=0; o<this.obsVal.entries.obs.length; o++){
                let out = 0;
                if(this.obsVal.entries.obs[o].startDate && this.obsVal.entries.obs[o].startTime && this.obsVal.entries.obs[o].stopDate && this.obsVal.entries.obs[o].stopTime){
                    let excl = 0;
                    for (let e=0; e<this.obsVal.entries.obs[o].exclusions.length; e++){
                        let ehours = (this.obsVal.entries.obs[o].exclusions[e].hours ? this.obsVal.entries.obs[o].exclusions[e].hours : 0),
                            emins = (this.obsVal.entries.obs[o].exclusions[e].minutes ? this.obsVal.entries.obs[o].exclusions[e].minutes : 0);
                        excl += Number(ehours) + Number(emins/60);
                    }
                    excl = Math.round(excl);
                    this.obsVal.entries.obs[o].exclusionHours = excl;
                    this.obsVal.totals.totalExclusions += excl;
                    let start = new Date(this.obsVal.entries.obs[o].startDate + "T" + this.obsVal.entries.obs[o].startTime),
                        stop = new Date(this.obsVal.entries.obs[o].stopDate + "T" + this.obsVal.entries.obs[o].stopTime);
                    if(start > stop){
                        out = 0;
                    }else{
                        let diff = Math.abs(start - stop),
                        hoursDiff = Math.round((diff/1000)/60/60);//-excl;
                        if(hoursDiff>0){
                            out = hoursDiff;
                        }
                    }
                }
                // console.log("TOTAL: " + out);
                this.obsVal.entries.obs[o].totalHours = out;
                this.obsVal.totals.totalHours += out;
            }
        },
        allCapArray(arr){
            for(let a=0; a<arr.length; a++){
                arr[a] = arr[a].toString().toUpperCase().replace(/\s+/g, '');
                let ind = arr.indexOf(arr[a]);
                if(ind != -1 && ind != a){
                    arr.splice(ind,1);
                }
            }
            let out = [...new Set(arr)]
            //// console.log("OUT: " + JSON.stringify(out));
            return out;
        },
        forceFormValidate(form){
            this.$refs[form].validate();
        },
        getProviderDetail:function(uuid){
            if(uuid){
                let provDet = this.$store.getters.Providers.find(x => x.uuid == uuid);
                return provDet.displayName + " (" + uuid + ")";
            }else{
                return "";
            }
        },
        async postData(url = "", data = {}) {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        async getData(url = "") {
            const session = await this.$Amplify.Auth.currentSession();
  const iT = session.getIdToken();
  const jwt = iT.getJwtToken();
            // Default options are marked with *
            const response = await fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                "Content-Type": "application/json",
                "Authorization": jwt
            },
            //redirect: 'follow', // manual, *follow, error
            //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
            return response.json(); // parses JSON response into native JavaScript objects
        },
        calcAge(){
            //// console.log("CALC AGE");
            this.menudob = false;
        },
        ageTator(dobin){
            //// console.log("DOB IN: " + dobin);
            let out;
            if(dobin && dobin.includes("/")){
                let dobarr = dobin.split("/"),
                    dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else if(dobin && dobin.includes("-")){
                let dobarr = dobin.split("-"),
                    dob = new Date(dobarr[0],dobarr[1],dobarr[2]),
                    diff = Date.now() - dob.getTime(),
                    age = new Date(diff);
                out = Math.abs(age.getUTCFullYear() - 1970);
            }else{
                out = null;
            }
            return out
        }
    }
  };
</script>

<style>
    .nextDay label{
        font-size: 14px;
        line-height: 14px !important;
        margin-left: -5px;
    }
    .theme--dark.v-tabs-items{
        background-color: unset;
    }
</style>